var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"attach-input",class:{ 'attach-input--disabled': _vm.disabled }},[_c('input',{ref:"input",attrs:{"type":"file","multiple":_vm.multiple,"disabled":_vm.disabled},on:{"change":_vm.handle}})])}
var staticRenderFns = []

export { render, staticRenderFns }